import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Colors, Fonts, Spacing, Typography } from '../constants';

export const EmptyStateNoItems: React.FC = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.emoji}>📦</Text>
      <Text style={[Typography.section, styles.title]}>No items available yet</Text>
      <Text style={styles.subtitle}>
        Check back soon! Your club members haven't listed any items yet.
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: Spacing.xl,
  },
  emoji: {
    fontSize: 64,
    marginBottom: Spacing.base,
  },
  title: {
    color: Colors.textDark,
    textAlign: 'center',
    marginBottom: Spacing.sm,
  },
  subtitle: {
    fontFamily: Fonts.regular,
    fontSize: 15,
    lineHeight: 23,
    color: Colors.textMedium,
    textAlign: 'center',
  },
});
